/**************************************************
 * Nombre:       Home_Nosotros
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import foto from '../../../Recursos/foto_nosotros.png'
import {NEGRITA} from "../../../Constantes";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Nosotros = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            background: sCell ?
                                `linear-gradient(180deg, rgba(46, 49, 146, 0.50) 0%, rgba(46, 49, 146, 0.80) 100%), url(${foto})`
                            :
                                `linear-gradient(180deg, rgba(46, 49, 146, 0.00) 40.94%, #2E3192 88.81%), url(${foto})`
                            ,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            color: '#fff',
                            p: 4,
                            borderRadius: 8
                        }}
                    >

                        {!sCell &&
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                                <Typography
                                    sx={{fontFamily: NEGRITA, fontWeight: 600, fontSize: 46}}>Nosotros</Typography>
                            </Grid>
                        }

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 0 :30}}>
                            <Typography sx={{fontFamily: NEGRITA, fontWeight: 600, fontSize: 40}}>Hotel Mar
                                Azul</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{fontWeight: 400, fontSize: 16, lineHeight: 1.2}}>
                                Fundado en 2007, el Hotel Mar Azul se ha consolidado como un refugio de hospitalidad en
                                el corazón de Tumaco, ofreciendo comodidad y tranquilidad tanto a viajeros de negocios
                                como a turistas. Con más de 17 años de experiencia, el hotel se ha renovado y sigue
                                comprometido con brindar una excelente atención a sus huéspedes.
                                <br/>
                                <br/>
                                Además, el hotel ha sido un aliado clave en el desarrollo local, ofreciendo alojamiento
                                a trabajadores de empresas y apoyando el turismo mediante su participación en el
                                calendario cultural y las festividades de Tumaco. Hoy en día, sigue siendo un pilar para
                                la comunidad, promoviendo el crecimiento económico y la identidad cultural de la ciudad.

                            </Typography>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Nosotros